/**
 * Single source of truth for the site URL.
 * Update SITE_URL here after the custom domain is confirmed in Vercel.
 */
export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://ai-bio-generator-steel.vercel.app";

export const SITE_NAME = "BioLoom";
export const SITE_TAGLINE = "AI-Powered Bio Generator";
export const SITE_DESCRIPTION =
  "Generate 4 unique, platform-optimized bios in seconds. 8 AI models, 5 platforms, 6 tones. Free forever — no signup required.";

export const SITE_KEYWORDS = [
  "AI bio generator",
  "LinkedIn bio generator",
  "Twitter bio generator",
  "Instagram bio generator",
  "GitHub bio generator",
  "professional bio AI",
  "personal bio writer",
  "AI writing tool",
  "social media bio",
  "personal branding",
  "free bio generator",
];

export const SITE_AUTHOR = "Zhenxiao Yu";
